<app-auth-navbar></app-auth-navbar>
<div class="container">
    <div class="row">
        <div class="col-md-4 col-12 mx-auto" style="margin-top: 250px;">
                <h3 class="signin_heading custom-heading text-center">Your passowrd has <br>been reset.</h3>
                <div class="text-center my-5">
                    <a href="#" class="terms">Return home.</a>
                </div>
        </div>
    </div>
</div>